import React from 'react';
import { useParams } from 'react-router-dom';

import SurveyInstanceContainer from '@totem/components/surveyV2/instanceDetail/SurveyInstanceContainer';
import SurveyInstanceDetailWrapper from '@totem/components/surveyV2/instanceDetail/surveyInstanceDetailWrapper';
const SurveyDetailPage = () => {
  const { id } = useParams();

  return (
    <SurveyInstanceContainer surveyInstanceId={id}>
      <SurveyInstanceDetailWrapper />
    </SurveyInstanceContainer>
  );
};

export default SurveyDetailPage;
